"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = void 0;
var storage = {
    to: function (key, value) {
        var json = JSON.stringify(value);
        localStorage.setItem(key, json);
        return json;
    },
    from: function (key, _default, _as) {
        if (_default === void 0) { _default = null; }
        if (_as === void 0) { _as = null; }
        var data = localStorage.getItem(key);
        var result = _default;
        if (data !== "null" && data !== null) {
            try {
                result = JSON.parse(data);
            }
            catch (e) {
                result = data;
            }
        }
        if (_as && result) {
            result = _as(result);
        }
        return result;
    },
    remove: function (key) {
        var value = storage.from(key);
        localStorage.removeItem(key);
        return value;
    },
};
exports.storage = storage;
//# sourceMappingURL=localStorage.js.map